import { apiPost } from "@/shared/api";

/** «Bonifico arrivato» su un ordine Kery: OM lo segna pagato su Shopify
 *  (orderMarkAsPaid) e poi in casa. Mai via Poleepo: Kery non c'e'. File a
 *  parte perche' ``api.ts`` e' oltre il tetto righe. */
export function confermaBonificoKery(
  orderRef: string,
): Promise<{ reference: string; esito: "segnato_pagato" | "gia_pagato" }> {
  return apiPost(`/api/orders/${encodeURIComponent(orderRef)}/bonifico-kery`, {});
}
